/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box, Typography, Avatar } from '@mui/material';
import './TerminationARModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import CompDirection from '../../../themes/CompDirection';
import { themes } from '../../../themes/themes';
import TakeActionSplitBtn from '../../../components/TakeActionSplitBtn/TakeActionSplitBtn';
import { DateField } from '../../../../components';
import { baseDateFormatting } from '../../../helper';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  userId: any;
  allActions?: any;
  trans?: any;
  fullData?: any;
  handleSubmitAR_Request?: any;
}

const TerminationARModalPresenter = ({
  isModalOpen,
  closeModal,
  userId,
  allActions,
  trans,
  fullData,
  handleSubmitAR_Request,
}: ModalProps) => {
  const handleTakeAction = (x: any) => {
    if (x) {
      const payload = {
        event: 'termination',
        instanceId: fullData?.id,
        userId: userId,
        action: x ? x : '',
        context: {},
        model: 'terminations',
      };
      handleSubmitAR_Request(payload);
    } else {
      return;
    }
  };
  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="98vh" modalWidth="23vw">
      <ModalHeader
        modal={{ modal_title: trans('Termination Action Required') }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '5px',
          }}
        >
          <Grid item xs={12}>
            <Box className="bg_border_ar_termination">
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Avatar />
                <Box style={{ paddingLeft: '10px' }}>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      color: themes.darkBlue,
                      fontSize: '1em',
                      fontWeight: 'bold',
                    }}
                  >
                    {fullData?.first_name + ' ' + fullData?.last_name}
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      color: themes.grey_colorDesignationAR,
                      fontSize: '0.825em',
                    }}
                  >
                    {fullData?.department_name} / {fullData?.designation_name}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Exit Date
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    <DateField
                      value={fullData?.notice_date}
                      format={baseDateFormatting}
                    />
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Termination Date
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    <DateField
                      value={fullData?.termination_date}
                      format={baseDateFormatting}
                    />
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Type of Contract
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.primaryMain,
                      backgroundColor: '#F2E6F0',
                      padding: '5px',
                      borderRadius: '4px',
                    }}
                  >
                    {fullData?.contract_type}
                  </Typography>
                </Box>
              </Box>

              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Attachment
                  </Typography>
                  <Box>
                    <a
                      href={fullData.attachment}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="las la-eye" color={themes.primary} />
                    </a>
                  </Box>
                </Box>
              </Box>
              <Box style={{ marginTop: '1.5em' }}>
                <CustomTextField
                  type="string"
                  label="Comment"
                  placeholder="Write Comment"
                />
              </Box>
              <Box style={{ marginTop: '1.5em', zIndex: '999', width: '100%' }}>
                <TakeActionSplitBtn
                  onAction={(x: any) => handleTakeAction(x)}
                  menu={allActions}
                  title={'Take Action'}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CompDirection>
    </CustomModal>
  );
};

export default TerminationARModalPresenter;
